import { render, staticRenderFns } from "./QuizPairing.vue?vue&type=template&id=18d5b618&"
import script from "./QuizPairing.vue?vue&type=script&lang=js&"
export * from "./QuizPairing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports